<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7813_12004)">
      <path
        d="M18.6866 24.8557C19.1258 24.6642 19.3085 24.3839 19.4405 24.219C20.6258 22.7385 18.0968 18.344 14.4861 15.8012C10.6593 12.469 6.44575 11.3335 5.26043 12.8141C5.05698 13.0682 4.89755 13.4143 4.83114 13.8049L2.58114 26.7502C2.50301 28.3284 3.10618 28.928 3.40802 29.221C3.95499 29.7519 5.01864 30.2034 6.12801 29.8127C10.4093 28.1643 14.42 26.7157 18.6866 24.8557Z"
        fill="url(#paint0_linear_7813_12004)"
      />
      <path
        d="M18.6866 24.8557C19.1258 24.6642 19.3085 24.3839 19.4405 24.219C20.6258 22.7385 18.0968 18.344 14.4861 15.8012C10.6593 12.469 6.44575 11.3335 5.26043 12.8141C5.05698 13.0682 4.89755 13.4143 4.83114 13.8049L2.58114 26.7502C2.50301 28.3284 3.10618 28.928 3.40802 29.221C3.95499 29.7519 5.01864 30.2034 6.12801 29.8127C10.4093 28.1643 14.42 26.7157 18.6866 24.8557Z"
        fill="url(#paint1_linear_7813_12004)"
      />
      <path
        d="M18.6866 24.8557C19.1258 24.6642 19.3085 24.3839 19.4405 24.219C20.6258 22.7385 18.0968 18.344 14.4861 15.8012C10.6593 12.469 6.44575 11.3335 5.26043 12.8141C5.05698 13.0682 4.89755 13.4143 4.83114 13.8049L2.58114 26.7502C2.50301 28.3284 3.10618 28.928 3.40802 29.221C3.95499 29.7519 5.01864 30.2034 6.12801 29.8127C10.4093 28.1643 14.42 26.7157 18.6866 24.8557Z"
        fill="url(#paint2_linear_7813_12004)"
      />
      <path
        d="M18.6866 24.8557C19.1258 24.6642 19.3085 24.3839 19.4405 24.219C20.6258 22.7385 18.0968 18.344 14.4861 15.8012C10.6593 12.469 6.44575 11.3335 5.26043 12.8141C5.05698 13.0682 4.89755 13.4143 4.83114 13.8049L2.58114 26.7502C2.50301 28.3284 3.10618 28.928 3.40802 29.221C3.95499 29.7519 5.01864 30.2034 6.12801 29.8127C10.4093 28.1643 14.42 26.7157 18.6866 24.8557Z"
        fill="url(#paint3_linear_7813_12004)"
      />
      <path
        d="M18.6866 24.8557C19.1258 24.6642 19.3085 24.3839 19.4405 24.219C20.6258 22.7385 18.0968 18.344 14.4861 15.8012C10.6593 12.469 6.44575 11.3335 5.26043 12.8141C5.05698 13.0682 4.89755 13.4143 4.83114 13.8049L2.58114 26.7502C2.50301 28.3284 3.10618 28.928 3.40802 29.221C3.95499 29.7519 5.01864 30.2034 6.12801 29.8127C10.4093 28.1643 14.42 26.7157 18.6866 24.8557Z"
        fill="url(#paint4_radial_7813_12004)"
      />
      <ellipse
        cx="12.5547"
        cy="18.187"
        rx="8.13023"
        ry="2.91536"
        transform="rotate(39.7456 12.5547 18.187)"
        fill="url(#paint5_linear_7813_12004)"
      />
      <ellipse
        cx="12.5547"
        cy="18.187"
        rx="8.13023"
        ry="2.91536"
        transform="rotate(39.7456 12.5547 18.187)"
        fill="url(#paint6_radial_7813_12004)"
      />
      <ellipse
        cx="12.5547"
        cy="18.187"
        rx="8.13023"
        ry="2.91536"
        transform="rotate(39.7456 12.5547 18.187)"
        fill="url(#paint7_radial_7813_12004)"
      />
      <circle
        cx="14.9561"
        cy="16"
        r="1.20312"
        fill="url(#paint8_radial_7813_12004)"
      />
      <circle
        cx="14.9561"
        cy="16"
        r="1.20312"
        fill="url(#paint9_radial_7813_12004)"
      />
      <circle
        cx="24.8311"
        cy="22.9062"
        r="1.20312"
        fill="url(#paint10_radial_7813_12004)"
      />
      <circle
        cx="24.8311"
        cy="22.9062"
        r="1.20312"
        fill="url(#paint11_radial_7813_12004)"
      />
      <circle
        cx="24.8311"
        cy="22.9062"
        r="1.20312"
        fill="url(#paint12_radial_7813_12004)"
      />
      <circle
        cx="23.8232"
        cy="7.01562"
        r="1.20312"
        fill="url(#paint13_radial_7813_12004)"
      />
      <circle
        cx="23.8232"
        cy="7.01562"
        r="1.20312"
        fill="url(#paint14_radial_7813_12004)"
      />
      <circle
        cx="9.99072"
        cy="3.36719"
        r="1.20312"
        fill="url(#paint15_radial_7813_12004)"
      />
      <circle
        cx="9.99072"
        cy="3.36719"
        r="1.20312"
        fill="url(#paint16_radial_7813_12004)"
      />
      <circle
        cx="9.99072"
        cy="3.36719"
        r="1.20312"
        fill="url(#paint17_radial_7813_12004)"
      />
      <circle
        cx="4.92822"
        cy="8.10938"
        r="1.20312"
        fill="url(#paint18_radial_7813_12004)"
      />
      <circle
        cx="4.92822"
        cy="8.10938"
        r="1.20312"
        fill="url(#paint19_radial_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.104 2.08211C19.6281 2.10661 20.0331 2.55134 20.0086 3.07544C19.9749 3.79703 19.8435 4.9991 19.5301 6.2831C19.2681 7.35635 18.8647 8.54675 18.2436 9.56732C18.3938 10.3635 18.3978 11.303 18.2329 12.3713C18.1529 12.8898 17.6677 13.2453 17.1491 13.1653C16.6306 13.0852 16.2751 12.6 16.3551 12.0815C16.392 11.8425 16.4182 11.6186 16.435 11.4091C16.2506 11.5053 16.0618 11.5807 15.869 11.6345C15.1159 11.845 14.3936 11.6991 13.8286 11.3227C12.7551 10.6077 12.2602 9.04289 13.0911 7.76362C13.8815 6.54665 15.5288 6.21578 16.7815 7.08162C16.9259 7.18146 17.0615 7.29394 17.1879 7.41876C17.3878 6.91334 17.5521 6.37403 17.6843 5.8325C17.9655 4.68072 18.082 3.60106 18.1107 2.98671C18.1352 2.46261 18.5799 2.05761 19.104 2.08211ZM16.1569 9.2226C16.0127 8.92228 15.8414 8.74153 15.7011 8.64459C15.3092 8.37371 14.8785 8.49987 14.6845 8.79852C14.4765 9.11877 14.5865 9.54467 14.8819 9.74147C15.0014 9.82103 15.1545 9.8614 15.3577 9.80462C15.5416 9.75324 15.823 9.60402 16.1569 9.2226Z"
        fill="url(#paint20_linear_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.104 2.08211C19.6281 2.10661 20.0331 2.55134 20.0086 3.07544C19.9749 3.79703 19.8435 4.9991 19.5301 6.2831C19.2681 7.35635 18.8647 8.54675 18.2436 9.56732C18.3938 10.3635 18.3978 11.303 18.2329 12.3713C18.1529 12.8898 17.6677 13.2453 17.1491 13.1653C16.6306 13.0852 16.2751 12.6 16.3551 12.0815C16.392 11.8425 16.4182 11.6186 16.435 11.4091C16.2506 11.5053 16.0618 11.5807 15.869 11.6345C15.1159 11.845 14.3936 11.6991 13.8286 11.3227C12.7551 10.6077 12.2602 9.04289 13.0911 7.76362C13.8815 6.54665 15.5288 6.21578 16.7815 7.08162C16.9259 7.18146 17.0615 7.29394 17.1879 7.41876C17.3878 6.91334 17.5521 6.37403 17.6843 5.8325C17.9655 4.68072 18.082 3.60106 18.1107 2.98671C18.1352 2.46261 18.5799 2.05761 19.104 2.08211ZM16.1569 9.2226C16.0127 8.92228 15.8414 8.74153 15.7011 8.64459C15.3092 8.37371 14.8785 8.49987 14.6845 8.79852C14.4765 9.11877 14.5865 9.54467 14.8819 9.74147C15.0014 9.82103 15.1545 9.8614 15.3577 9.80462C15.5416 9.75324 15.823 9.60402 16.1569 9.2226Z"
        fill="url(#paint21_radial_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.104 2.08211C19.6281 2.10661 20.0331 2.55134 20.0086 3.07544C19.9749 3.79703 19.8435 4.9991 19.5301 6.2831C19.2681 7.35635 18.8647 8.54675 18.2436 9.56732C18.3938 10.3635 18.3978 11.303 18.2329 12.3713C18.1529 12.8898 17.6677 13.2453 17.1491 13.1653C16.6306 13.0852 16.2751 12.6 16.3551 12.0815C16.392 11.8425 16.4182 11.6186 16.435 11.4091C16.2506 11.5053 16.0618 11.5807 15.869 11.6345C15.1159 11.845 14.3936 11.6991 13.8286 11.3227C12.7551 10.6077 12.2602 9.04289 13.0911 7.76362C13.8815 6.54665 15.5288 6.21578 16.7815 7.08162C16.9259 7.18146 17.0615 7.29394 17.1879 7.41876C17.3878 6.91334 17.5521 6.37403 17.6843 5.8325C17.9655 4.68072 18.082 3.60106 18.1107 2.98671C18.1352 2.46261 18.5799 2.05761 19.104 2.08211ZM16.1569 9.2226C16.0127 8.92228 15.8414 8.74153 15.7011 8.64459C15.3092 8.37371 14.8785 8.49987 14.6845 8.79852C14.4765 9.11877 14.5865 9.54467 14.8819 9.74147C15.0014 9.82103 15.1545 9.8614 15.3577 9.80462C15.5416 9.75324 15.823 9.60402 16.1569 9.2226Z"
        fill="url(#paint22_radial_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.104 2.08211C19.6281 2.10661 20.0331 2.55134 20.0086 3.07544C19.9749 3.79703 19.8435 4.9991 19.5301 6.2831C19.2681 7.35635 18.8647 8.54675 18.2436 9.56732C18.3938 10.3635 18.3978 11.303 18.2329 12.3713C18.1529 12.8898 17.6677 13.2453 17.1491 13.1653C16.6306 13.0852 16.2751 12.6 16.3551 12.0815C16.392 11.8425 16.4182 11.6186 16.435 11.4091C16.2506 11.5053 16.0618 11.5807 15.869 11.6345C15.1159 11.845 14.3936 11.6991 13.8286 11.3227C12.7551 10.6077 12.2602 9.04289 13.0911 7.76362C13.8815 6.54665 15.5288 6.21578 16.7815 7.08162C16.9259 7.18146 17.0615 7.29394 17.1879 7.41876C17.3878 6.91334 17.5521 6.37403 17.6843 5.8325C17.9655 4.68072 18.082 3.60106 18.1107 2.98671C18.1352 2.46261 18.5799 2.05761 19.104 2.08211ZM16.1569 9.2226C16.0127 8.92228 15.8414 8.74153 15.7011 8.64459C15.3092 8.37371 14.8785 8.49987 14.6845 8.79852C14.4765 9.11877 14.5865 9.54467 14.8819 9.74147C15.0014 9.82103 15.1545 9.8614 15.3577 9.80462C15.5416 9.75324 15.823 9.60402 16.1569 9.2226Z"
        fill="url(#paint23_radial_7813_12004)"
      />
      <path
        d="M15.9526 26.0091C13.3466 25.828 11.5188 25.048 8.55753 22.6014C6.01012 20.4967 4.74539 18.6296 4.32327 16.7256L3.83423 19.5393C4.0341 20.6405 4.89347 22.1796 6.5966 23.7186C8.82409 25.7315 11.0419 27.1561 13.2352 27.0937C14.1378 26.7412 15.0418 26.3818 15.9526 26.0091Z"
        fill="url(#paint24_radial_7813_12004)"
      />
      <path
        d="M10.4569 28.1627C9.20447 28.2326 7.51066 27.2108 5.75285 25.7498C4.25285 24.4529 3.51295 23.044 3.35722 22.2837L2.8606 25.141C2.98344 25.6241 3.35755 26.2806 4.44035 27.3904C5.65114 28.6315 6.86874 29.1145 7.59181 29.2518C8.10488 29.0563 8.61485 28.8626 9.12267 28.6698C9.56889 28.5004 10.0134 28.3316 10.4569 28.1627Z"
        fill="url(#paint25_radial_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.9031 13.1088C24.3053 12.4059 22.1793 14.0542 21.5054 14.7934C21.1147 15.222 20.4506 15.2527 20.0221 14.862C19.5935 14.4714 19.5628 13.8073 19.9535 13.3787C20.9983 12.2325 23.8255 10.1725 28.3058 11.0478C28.8749 11.1589 29.2462 11.7105 29.135 12.2796C29.0238 12.8487 28.4723 13.22 27.9031 13.1088Z"
        fill="url(#paint26_radial_7813_12004)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.9031 13.1088C24.3053 12.4059 22.1793 14.0542 21.5054 14.7934C21.1147 15.222 20.4506 15.2527 20.0221 14.862C19.5935 14.4714 19.5628 13.8073 19.9535 13.3787C20.9983 12.2325 23.8255 10.1725 28.3058 11.0478C28.8749 11.1589 29.2462 11.7105 29.135 12.2796C29.0238 12.8487 28.4723 13.22 27.9031 13.1088Z"
        fill="url(#paint27_radial_7813_12004)"
      />
      <path
        d="M12.855 8.21156C12.9164 8.05974 12.994 7.90995 13.0888 7.76388C13.8793 6.54691 15.5266 6.21604 16.7792 7.08188C16.9237 7.18172 17.0593 7.2942 17.1857 7.41902C17.2265 7.31575 17.2659 7.21107 17.3038 7.10524C17.3057 7.11164 17.3075 7.11801 17.3093 7.12434C17.052 7.93488 16.4746 8.80257 16.1539 9.22117C16.0098 8.92186 15.8389 8.74161 15.6989 8.64485C15.307 8.37397 14.8762 8.50013 14.6823 8.79878C14.6747 8.8104 14.6676 8.82216 14.6609 8.83405L12.855 8.21156Z"
        fill="url(#paint28_radial_7813_12004)"
      />
      <path
        d="M12.855 8.21156C12.9164 8.05974 12.994 7.90995 13.0888 7.76388C13.8793 6.54691 15.5266 6.21604 16.7792 7.08188C16.9237 7.18172 17.0593 7.2942 17.1857 7.41902C17.2265 7.31575 17.2659 7.21107 17.3038 7.10524C17.3057 7.11164 17.3075 7.11801 17.3093 7.12434C17.052 7.93488 16.4746 8.80257 16.1539 9.22117C16.0098 8.92186 15.8389 8.74161 15.6989 8.64485C15.307 8.37397 14.8762 8.50013 14.6823 8.79878C14.6747 8.8104 14.6676 8.82216 14.6609 8.83405L12.855 8.21156Z"
        fill="url(#paint29_radial_7813_12004)"
      />
      <path
        d="M17.2844 16.8523C21.4414 14.7572 26.0247 15.8941 27.8928 16.6345C28.5345 16.8889 28.8492 17.6158 28.595 18.2575C28.3406 18.8993 27.6137 19.2131 26.9719 18.9587C25.371 18.3241 21.6274 17.4628 18.4094 19.0847C16.2878 20.1541 14.7103 21.5925 13.843 22.6052C13.1589 22.227 12.447 21.7678 11.7297 21.239C12.8165 19.8928 14.7558 18.1269 17.2844 16.8523Z"
        fill="url(#paint30_linear_7813_12004)"
      />
      <path
        d="M17.2844 16.8523C21.4414 14.7572 26.0247 15.8941 27.8928 16.6345C28.5345 16.8889 28.8492 17.6158 28.595 18.2575C28.3406 18.8993 27.6137 19.2131 26.9719 18.9587C25.371 18.3241 21.6274 17.4628 18.4094 19.0847C16.2878 20.1541 14.7103 21.5925 13.843 22.6052C13.1589 22.227 12.447 21.7678 11.7297 21.239C12.8165 19.8928 14.7558 18.1269 17.2844 16.8523Z"
        fill="url(#paint31_radial_7813_12004)"
      />
      <path
        d="M17.2844 16.8523C21.4414 14.7572 26.0247 15.8941 27.8928 16.6345C28.5345 16.8889 28.8492 17.6158 28.595 18.2575C28.3406 18.8993 27.6137 19.2131 26.9719 18.9587C25.371 18.3241 21.6274 17.4628 18.4094 19.0847C16.2878 20.1541 14.7103 21.5925 13.843 22.6052C13.1589 22.227 12.447 21.7678 11.7297 21.239C12.8165 19.8928 14.7558 18.1269 17.2844 16.8523Z"
        fill="url(#paint32_radial_7813_12004)"
      />
      <path
        d="M17.2844 16.8523C21.4414 14.7572 26.0247 15.8941 27.8928 16.6345C28.5345 16.8889 28.8492 17.6158 28.595 18.2575C28.3406 18.8993 27.6137 19.2131 26.9719 18.9587C25.371 18.3241 21.6274 17.4628 18.4094 19.0847C16.2878 20.1541 14.7103 21.5925 13.843 22.6052C13.1589 22.227 12.447 21.7678 11.7297 21.239C12.8165 19.8928 14.7558 18.1269 17.2844 16.8523Z"
        fill="url(#paint33_radial_7813_12004)"
      />
      <path
        d="M8.49219 6.16909C9.09538 5.8336 9.85575 6.05034 10.1914 6.65346C10.7626 7.68001 11.6072 9.37086 11.7148 11.6017C11.8188 13.7587 11.2274 16.2943 9.28027 19.1271C8.62028 18.4761 8.04415 17.8201 7.56641 17.1876C8.94687 14.9931 9.28735 13.1644 9.21777 11.7218C9.13789 10.066 8.51373 8.78023 8.00684 7.86928C7.67116 7.26603 7.88894 6.50477 8.49219 6.16909Z"
        fill="url(#paint34_radial_7813_12004)"
      />
      <path
        d="M8.49219 6.16909C9.09538 5.8336 9.85575 6.05034 10.1914 6.65346C10.7626 7.68001 11.6072 9.37086 11.7148 11.6017C11.8188 13.7587 11.2274 16.2943 9.28027 19.1271C8.62028 18.4761 8.04415 17.8201 7.56641 17.1876C8.94687 14.9931 9.28735 13.1644 9.21777 11.7218C9.13789 10.066 8.51373 8.78023 8.00684 7.86928C7.67116 7.26603 7.88894 6.50477 8.49219 6.16909Z"
        fill="url(#paint35_radial_7813_12004)"
      />
      <path
        d="M18.2416 9.56836C18.3917 10.3644 18.3956 11.3036 18.2308 12.3715C18.1508 12.89 17.6656 13.2455 17.147 13.1654C16.6285 13.0854 16.273 12.6002 16.353 12.0817C16.3899 11.8431 16.416 11.6196 16.4328 11.4105C17.4148 10.794 18.0631 9.97364 18.2416 9.56836Z"
        fill="url(#paint36_radial_7813_12004)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_7813_12004"
        x1="4.22176"
        y1="19.9846"
        x2="12.2843"
        y2="26.9846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3843C" />
        <stop
          offset="1"
          stop-color="#F17A61"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7813_12004"
        x1="3.33085"
        y1="21.0679"
        x2="5.69051"
        y2="21.5471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B1853B" />
        <stop
          offset="1"
          stop-color="#B1853B"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7813_12004"
        x1="19.7359"
        y1="23.8284"
        x2="15.753"
        y2="24.4846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9C26C" />
        <stop
          offset="1"
          stop-color="#F9C26C"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7813_12004"
        x1="11.1551"
        y1="12.3909"
        x2="8.59676"
        y2="16.7346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E6BF69" />
        <stop
          offset="1"
          stop-color="#E6BF69"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint4_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.6032 17.9064) rotate(-49.3383) scale(4.35332 10.202)"
      >
        <stop
          stop-color="#F5BD55"
          stop-opacity="0"
        />
        <stop
          offset="0.836376"
          stop-color="#FCCB57"
        />
        <stop
          offset="1"
          stop-color="#FCCB57"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint5_linear_7813_12004"
        x1="5.14761"
        y1="17.8647"
        x2="21.6275"
        y2="18.6702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3AB2C" />
        <stop
          offset="1"
          stop-color="#B57F1E"
        />
      </linearGradient>
      <radialGradient
        id="paint6_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.45378 20.521) rotate(-109.125) scale(6.4775 1.81427)"
      >
        <stop
          offset="0.423414"
          stop-color="#CA851E"
        />
        <stop
          offset="1"
          stop-color="#CA851E"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint7_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.2356 20.6121) rotate(-73.0972) scale(6.50954 3.81205)"
      >
        <stop stop-color="#BC7F28" />
        <stop
          offset="1"
          stop-color="#BC7F28"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint8_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.4873 15.6719) rotate(138.668) scale(1.72711)"
      >
        <stop stop-color="#5AC0FF" />
        <stop
          offset="1"
          stop-color="#3279B6"
        />
      </radialGradient>
      <radialGradient
        id="paint9_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.1928 15.8342) rotate(160.051) scale(1.73439 1.90111)"
      >
        <stop
          offset="0.534713"
          stop-color="#3A619E"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#3A619E"
        />
      </radialGradient>
      <radialGradient
        id="paint10_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.5282 22.3978) rotate(134.569) scale(1.97753)"
      >
        <stop stop-color="#FDD46C" />
        <stop
          offset="1"
          stop-color="#F09C53"
        />
      </radialGradient>
      <radialGradient
        id="paint11_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.0551 22.2927) rotate(100.827) scale(1.95883)"
      >
        <stop
          offset="0.792052"
          stop-color="#E76260"
          stop-opacity="0"
        />
        <stop
          offset="0.964251"
          stop-color="#E76260"
        />
      </radialGradient>
      <radialGradient
        id="paint12_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.4051 23.1048) rotate(-147.558) scale(1.98371 2.33609)"
      >
        <stop
          offset="0.482355"
          stop-color="#AA885A"
          stop-opacity="0"
        />
        <stop
          offset="0.90682"
          stop-color="#AA885A"
        />
      </radialGradient>
      <radialGradient
        id="paint13_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.6848 6.54746) rotate(132.387) scale(2.06012)"
      >
        <stop stop-color="#FF46AA" />
        <stop
          offset="1"
          stop-color="#E3189D"
        />
      </radialGradient>
      <radialGradient
        id="paint14_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.3311 7.23437) rotate(-173.29) scale(1.8722 2.50559)"
      >
        <stop
          offset="0.522105"
          stop-color="#B63173"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#B63173"
        />
      </radialGradient>
      <radialGradient
        id="paint15_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.7791 2.8856) rotate(139.574) scale(1.84118)"
      >
        <stop stop-color="#FFF46F" />
        <stop
          offset="1"
          stop-color="#EFB93C"
        />
      </radialGradient>
      <radialGradient
        id="paint16_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.5157 3.17236) rotate(-178.519) scale(1.91464 1.82297)"
      >
        <stop
          offset="0.558644"
          stop-color="#AA904B"
          stop-opacity="0"
        />
        <stop
          offset="0.943632"
          stop-color="#AA904B"
        />
      </radialGradient>
      <radialGradient
        id="paint17_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.2996 2.6875) rotate(102.339) scale(2.04729)"
      >
        <stop
          offset="0.771901"
          stop-color="#C47072"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#C47072"
        />
      </radialGradient>
      <radialGradient
        id="paint18_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.7898 7.64121) rotate(132.387) scale(2.06012)"
      >
        <stop stop-color="#FF46AA" />
        <stop
          offset="1"
          stop-color="#E3189D"
        />
      </radialGradient>
      <radialGradient
        id="paint19_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.43604 8.32812) rotate(-173.29) scale(1.8722 2.50559)"
      >
        <stop
          offset="0.522105"
          stop-color="#B63173"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#B63173"
        />
      </radialGradient>
      <linearGradient
        id="paint20_linear_7813_12004"
        x1="19.0623"
        y1="2.08105"
        x2="14.5804"
        y2="12.8227"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#20B2EE" />
        <stop
          offset="1"
          stop-color="#2689DA"
        />
      </linearGradient>
      <radialGradient
        id="paint21_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.0785 5.57046) rotate(128.217) scale(7.76064 4.747)"
      >
        <stop
          offset="0.80204"
          stop-color="#4274D2"
          stop-opacity="0"
        />
        <stop
          offset="0.950917"
          stop-color="#4274D2"
        />
      </radialGradient>
      <radialGradient
        id="paint22_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.6903 4.67169) rotate(12.0948) scale(1.11858 3.75515)"
      >
        <stop stop-color="#4D8EC0" />
        <stop
          offset="1"
          stop-color="#4D8EC0"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint23_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.9091 2.24982) rotate(141.953) scale(1.36904 1.23086)"
      >
        <stop stop-color="#5ADEFF" />
        <stop
          offset="1"
          stop-color="#5ADEFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint24_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.2216 25.078) rotate(133.21) scale(4.24471 9.2935)"
      >
        <stop stop-color="#3365FF" />
        <stop
          offset="1"
          stop-color="#356DB9"
        />
      </radialGradient>
      <radialGradient
        id="paint25_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.4091 28.0154) rotate(131.598) scale(2.62017 6.62793)"
      >
        <stop stop-color="#3365FF" />
        <stop
          offset="1"
          stop-color="#356DB9"
        />
      </radialGradient>
      <radialGradient
        id="paint26_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.5341 11.8908) rotate(168.283) scale(4.30854 1.60742)"
      >
        <stop stop-color="#FF3BA9" />
        <stop
          offset="1"
          stop-color="#F422A7"
        />
      </radialGradient>
      <radialGradient
        id="paint27_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.417 15.3283) rotate(-127.355) scale(4.44241 7.91727)"
      >
        <stop
          offset="0.752144"
          stop-color="#B8306F"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#B8306F"
        />
      </radialGradient>
      <radialGradient
        id="paint28_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.0266 9.34144) rotate(-131.325) scale(2.94473 2.20121)"
      >
        <stop stop-color="#336BAF" />
        <stop
          offset="1"
          stop-color="#336BAF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint29_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.3093 7.45309) rotate(-127.657) scale(1.85511 0.751608)"
      >
        <stop stop-color="#49A4D4" />
        <stop
          offset="1"
          stop-color="#49A4D4"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint30_linear_7813_12004"
        x1="14.4528"
        y1="21.6941"
        x2="27.8599"
        y2="18.1807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3797E2" />
        <stop
          offset="1"
          stop-color="#37AEFF"
        />
      </linearGradient>
      <radialGradient
        id="paint31_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-5.1113 -6.12681 15.3575 -12.8131 19.412 23.8864)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.622552"
          stop-color="#526579"
          stop-opacity="0"
        />
        <stop
          offset="0.962126"
          stop-color="#526579"
        />
      </radialGradient>
      <radialGradient
        id="paint32_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-0.210053 2.73081 -5.49008 -0.422331 23.8931 19.5801)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.396078"
          stop-color="#6972FF"
        />
        <stop
          offset="1"
          stop-color="#6972FF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint33_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0.271319 -0.700207 0.552172 0.213976 27.9542 17.2782)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#55BFFF" />
        <stop
          offset="1"
          stop-color="#55BFFF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint34_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-1.19695 7.21141 -2.70203 -0.448369 10.8433 6.43646)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF3AAA" />
        <stop
          offset="1"
          stop-color="#FD2F89"
        />
      </radialGradient>
      <radialGradient
        id="paint35_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(4.11355 2.48855 -7.81079 12.9078 7.02617 13.9745)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.803698"
          stop-color="#DB2C6E"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="#DB2C6E"
        />
      </radialGradient>
      <radialGradient
        id="paint36_radial_7813_12004"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.8438 11.3725) rotate(98.0559) scale(3.53738 1.96871)"
      >
        <stop stop-color="#4AB5F8" />
        <stop
          offset="1"
          stop-color="#4AB5F8"
          stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7813_12004">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
